import { render, staticRenderFns } from "./lottery-data.vue?vue&type=template&id=bec3f276&scoped=true&"
import script from "./lottery-data.vue?vue&type=script&lang=js&"
export * from "./lottery-data.vue?vue&type=script&lang=js&"
import style0 from "./lottery-data.vue?vue&type=style&index=0&id=bec3f276&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec3f276",
  null
  
)

export default component.exports